import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldTitle,
} from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/client/components/shad/radio-group";
import { Separator } from "@/client/components/shad/separator";
import { Switch } from "@/client/components/shad/switch";
import { useTopic } from "@/hooks/useTopic";
import { useEffect, useState } from "react";

export const PdarControls = () => {
  const { sendCommand } = useTopic<unknown>("pdar/config");

  const handleAoAChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "aoas",
      enabled,
    });
  };

  const handleWiFiChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "wifi",
      enabled,
    });
  };

  const handlePilotChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "pilot",
      enabled,
    });
  };

  const handleDroneChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "drone",
      enabled,
    });
  };

  const handleHeatmapChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "heatmap",
      enabled,
    });
  };

  const handleOtherChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "other",
      enabled,
    });
  };

  const handleTargetChange = (enabled: boolean) => {
    sendCommand("pdar/config", {
      value: "target",
      enabled,
    });
  };

  return (
    <div className="grid gap-10">
      <div className="px-1 space-y-3">
        <div className="pb-0">
          <p className="text-muted-foreground">PDAR</p>
        </div>

        <FieldGroup className="w-full gap-3">
          <FieldLabel htmlFor="switch-aoa">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show AoAs</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleAoAChange}
                size="sm"
                id="switch-aoa"
                defaultChecked
              />
            </Field>
          </FieldLabel>
          <FieldLabel htmlFor="switch-heatmap">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show Heatmap</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleHeatmapChange}
                size="sm"
                id="switch-heatmap"
                defaultChecked
              />
            </Field>
          </FieldLabel>
          <FieldLabel htmlFor="switch-target">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show Target</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleTargetChange}
                size="sm"
                id="switch-target"
                defaultChecked
              />
            </Field>
          </FieldLabel>
        </FieldGroup>
      </div>

      <div className="px-1 space-y-3">
        <div className="pb-0">
          <p className="text-muted-foreground">Multi Switch</p>
        </div>

        <FieldGroup className="w-full gap-3">
          <FieldLabel htmlFor="switch-pilot">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show Pilot</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handlePilotChange}
                size="sm"
                id="switch-pilot"
                defaultChecked
              />
            </Field>
          </FieldLabel>
          <FieldLabel htmlFor="switch-drone">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show Drone</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleDroneChange}
                size="sm"
                id="switch-drone"
                defaultChecked
              />
            </Field>
          </FieldLabel>
          <FieldLabel htmlFor="switch-wifi">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show WiFI</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleWiFiChange}
                size="sm"
                id="switch-wifi"
                defaultChecked
              />
            </Field>
          </FieldLabel>
          <FieldLabel htmlFor="switch-other">
            <Field orientation="horizontal">
              <FieldContent>
                <FieldTitle className="text-xs">Show Other</FieldTitle>
              </FieldContent>
              <Switch
                onCheckedChange={handleOtherChange}
                size="sm"
                id="switch-other"
                defaultChecked
              />
            </Field>
          </FieldLabel>
        </FieldGroup>
      </div>
    </div>
  );
};
